/**
 * Seuils paramétrables (`10-parametrage-administration.md`) : tous, y compris ceux jamais modifiés,
 * avec `configure: false` et leur origine documentée (CDC, proposition par défaut…).
 */
import { useState } from "react";

import { ErreurApi } from "../../shared/api/erreurs";
import { Chargement, Erreur } from "../../shared/composants/Etats";
import { useModifierSeuil, useSeuils } from "./requetes";

export function EcranSeuils() {
  const requete = useSeuils();
  const modifier = useModifierSeuil();
  const [enEdition, definirEnEdition] = useState<string | null>(null);
  const [valeur, definirValeur] = useState("");

  const seuils = requete.data?.data ?? {};
  const indicateurs = Object.keys(seuils).sort();

  async function soumettre(indicateur: string, evenement: React.FormEvent) {
    evenement.preventDefault();
    const nombre = Number(valeur);
    if (Number.isNaN(nombre)) return;
    await modifier.mutateAsync({ indicateur, corps: { valeur: nombre } });
    definirEnEdition(null);
  }

  if (requete.isPending) return <Chargement libelle="Chargement des seuils…" />;
  if (requete.isError) return <Erreur erreur={requete.error} reessayer={() => void requete.refetch()} />;

  return (
    <section>
      <h1>Seuils</h1>
      <table className="tableau">
        <thead>
          <tr>
            <th scope="col">Seuil</th>
            <th scope="col">Valeur</th>
            <th scope="col">Configuré</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {indicateurs.map((indicateur) => {
            const seuil = seuils[indicateur]!;
            return (
              <tr key={indicateur}>
                <td>{seuil.libelle}</td>
                <td>
                  {seuil.valeurs ? seuil.valeurs.join(" / ") : (seuil.valeur ?? "—")} {seuil.unite}
                </td>
                <td>{seuil.configure ? "oui" : "non (valeur par défaut)"}</td>
                <td>
                  {enEdition === indicateur ? (
                    <form
                      className="formulaire-ligne"
                      onSubmit={(e) => void soumettre(indicateur, e)}
                    >
                      <input
                        aria-label={`Nouvelle valeur pour ${seuil.libelle}`}
                        type="number"
                        step="any"
                        required
                        value={valeur}
                        onChange={(e) => definirValeur(e.target.value)}
                      />
                      <button type="submit" disabled={modifier.isPending}>
                        Enregistrer
                      </button>
                      <button type="button" onClick={() => definirEnEdition(null)}>
                        Annuler
                      </button>
                    </form>
                  ) : (
                    !seuil.valeurs && (
                      <button
                        type="button"
                        onClick={() => {
                          definirEnEdition(indicateur);
                          definirValeur(String(seuil.valeur ?? ""));
                        }}
                      >
                        Modifier
                      </button>
                    )
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {modifier.isError && (
        <p role="alert">
          {modifier.error instanceof ErreurApi ? modifier.error.message : "La modification a échoué."}
        </p>
      )}
    </section>
  );
}
